import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export class ListButton extends React.PureComponent {
  static propTypes = {
    name: PropTypes.node,
    render: PropTypes.func,
    onClick: PropTypes.func,
    className: PropTypes.string
  }
  static defaultProps = {
    className: 'px-4 py-1'
  }

  handleClick = (e) => {
    const { onClick } = this.props
    if (typeof e.stopPropagation === 'function') e.stopPropagation()

    if (typeof onClick === 'function') onClick()
  }

  render() {
    const { name, render, className } = this.props

    const blockClasses = classNames([
      'w-full',
      'my-1',
      'text-xs',
      'font-header',
      'text-left',
      'cursor-pointer',
      'break-words-everywhere',
      className
    ])

    const content = typeof render === 'function' ? render() : name

    //Change to div since sometimes need to nest it with some other buttons.
    return (
      <div
        role="button"
        tabIndex="0"
        className={`listButton ${blockClasses}`}
        onClick={this.handleClick}
      >
        {content}
      </div>
    )
  }
}
